// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleView_root__GjSuE"};